<template>
  <div class="jumping-beads-container">
    <div
      v-for="i in 5"
      :key="i"
      class="bead"
      :style="{ animationDelay: `${(i - 1) * 0.2}s` }"
    />
  </div>
</template>

<style lang="scss" scoped>
.jumping-beads-container {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 40px;
}

.bead {
  width: 10px;
  height: 10px;
  background-color: map.get(v.$primary, "500");
  border-radius: 50%;
  animation: jump 1.2s ease-in-out infinite;
}

@keyframes jump {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}
</style>
